import $ from 'jquery';

export default function Day(vm) {
    this.all = function(params) {
        var url = '/day/list?' + $.param(params);

        return vm.get(url);
    };
}